import React from 'react';
import FormBlock from './FormBlock';
import { Controller, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { ComboboxNamHoc } from '../../../components/combobox-namhoc';
import { IHocSinh } from '../../../models/response/crm-hocsinh/IHocsinh';
import { crmHocSinhApi } from '../../../api/crmHocSinhApi';
import { Box, FormControl, IconButton } from '@primer/react';
import { SyncIcon } from '@primer/octicons-react';
import TextInput from '../../../components/ui/text-input';
import StyledDatePicker from '../../../components/react-datepicker-style/ReactDatePicker';
import ComboboxGioiTinh from '../../../components/combobox-gioitinh';
import ComboboxDanToc from '../../../components/combobox-dantoc';
import ComboboxTonGiao from '../../../components/combobox-tongiao';
import ComboboxQuocTich from '../../../components/combobox-quoctich';
import { ComboboxTrangThaiHocSinh } from '../../../components/combobox-trangthaihocsinh';
interface IThongTinHocSinhProps {
    control: any,
    hocSinh: IHocSinh,
    setFormData: React.Dispatch<React.SetStateAction<IHocSinh>>,
    setValue: UseFormSetValue<IHocSinh>,
    register: any,
    errors: any,
    formData: IHocSinh,
    trigger: UseFormTrigger<IHocSinh>,
    onReloadMaHs?: () => void,
    isReloadingMaHs?: boolean

}
const ThongTinHocSinh = (props: IThongTinHocSinhProps) => {
    const { control, setFormData, hocSinh, setValue, register, errors, formData, trigger, onReloadMaHs, isReloadingMaHs } = props;
    return (
        <FormBlock caption='Thông tin học sinh'>
            <Box sx={{
                display: "grid",
                gap: 3,
                gridTemplateColumns: "repeat(4, 1fr)"
            }}>
                {/* Hàng 1 */}
                <Controller
                    name="nam_hoc"
                    control={control as any}
                    rules={{ required: "Vui lòng chọn năm học" }}
                    render={({ field }) => (
                        <FormControl>
                            <FormControl.Label>Năm học</FormControl.Label>
                            <ComboboxNamHoc
                                value={field.value}
                                onValueChanged={async (value) => {
                                    field.onChange(value);
                                    setFormData((prev) => ({
                                        ...prev,
                                        nam_hoc: value,
                                    }));

                                    if (hocSinh.id > 0) {
                                        try {
                                            const res = await crmHocSinhApi.getHSCCById(
                                                hocSinh.id,
                                                value
                                            );
                                            if (res.is_success && res.data) {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    dm_truong_id: res.data.dm_truong_id || 0,
                                                    dm_khoi_id: res.data.dm_khoi_id || 0,
                                                    dm_he_id: res.data.dm_he_id || 0,
                                                    dm_lop_id: res.data.dm_lop_id || 0,
                                                    dm_trangthaihocsinh_id:
                                                        res.data.dm_trangthaihocsinh_id || 0,
                                                }));

                                                const defaultValues = {
                                                    dm_truong_id: res.data.dm_truong_id || 0,
                                                    dm_khoi_id: res.data.dm_khoi_id || 0,
                                                    dm_he_id: res.data.dm_he_id || 0,
                                                    dm_lop_id: res.data.dm_lop_id || 0,
                                                    dm_trangthaihocsinh_id:
                                                        res.data.dm_trangthaihocsinh_id || 0,
                                                };

                                                Object.entries(defaultValues).forEach(
                                                    ([key, val]) => {
                                                        setValue(key as keyof IHocSinh, val);
                                                    }
                                                );
                                            } else {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    dm_truong_id: 0,
                                                    dm_khoi_id: 0,
                                                    dm_he_id: 0,
                                                    dm_lop_id: 0,
                                                    dm_trangthaihocsinh_id: 0,
                                                }));

                                                const defaultValues = {
                                                    dm_truong_id: 0,
                                                    dm_khoi_id: 0,
                                                    dm_he_id: 0,
                                                    dm_lop_id: 0,
                                                    dm_trangthaihocsinh_id: 0,
                                                };

                                                Object.entries(defaultValues).forEach(
                                                    ([key, val]) => {
                                                        setValue(key as keyof IHocSinh, val);
                                                    }
                                                );
                                            }
                                        } catch (error) {
                                            console.error("Error fetching data:", error);
                                        }
                                    }
                                }}
                            />
                        </FormControl>
                    )}
                />

                <FormControl>
                    <FormControl.Label>Mã KH</FormControl.Label>
                    <TextInput
                        block
                        name="ma_kh"
                        register={register}
                        errors={errors}
                        required={false}
                    />
                </FormControl>

                <Controller
                    name="ma_hs"
                    control={control}
                    rules={{
                        validate: (value) => {
                            if (!value) return true;
                            if (!/^(ED\d{10}|TN\d{6})$/.test(value))
                                return "Mã học sinh phải có dạng ED + 10 chữ số (VD: ED0325370001) hoặc TN + 6 chữ số";
                            return true;
                        }
                    }}
                    render={({ field }) => {
                        const isMaHsDisabled = !(formData.dm_truong_id && formData.nam_nhap_hoc && formData.dm_khoi_id);
                        return (
                            <FormControl>
                                <FormControl.Label>Mã học sinh</FormControl.Label>
                                <Box sx={{ position: "relative" }}>
                                    <TextInput
                                        block
                                        {...field}
                                        sx={{ pr: "36px" }}
                                        value={field.value || ""}
                                        disabled={isMaHsDisabled}
                                        onChange={(event) => {
                                            field.onChange(event.target.value);
                                            setFormData((prev) => ({
                                                ...prev,
                                                ma_hs: event.target.value,
                                            }));
                                        }}
                                    />
                                    <IconButton
                                        icon={SyncIcon}
                                        aria-label="Sinh lại mã học sinh"
                                        variant="invisible"
                                        size="small"
                                        disabled={isReloadingMaHs || isMaHsDisabled}
                                        sx={{
                                            position: "absolute",
                                            top: "50%",
                                            right: "4px",
                                            transform: "translateY(-50%)",
                                            minWidth: "28px",
                                            width: "28px",
                                            height: "28px",
                                            color: "fg.muted",
                                            zIndex: 1,
                                        }}
                                        onClick={() => {
                                            onReloadMaHs && onReloadMaHs();
                                        }}
                                    />
                                </Box>
                                {errors.ma_hs && (
                                    <FormControl.Validation variant="error">
                                        {errors.ma_hs.message}
                                    </FormControl.Validation>
                                )}
                            </FormControl>
                        );
                    }}
                />

                <Controller
                    name="dm_trangthaihocsinh_id"
                    control={control}
                    rules={{ required: "Vui lòng chọn trạng thái học sinh" }}
                    render={({ field }) => (
                        <FormControl>
                            <FormControl.Label>Trạng thái học sinh</FormControl.Label>
                            <ComboboxTrangThaiHocSinh
                                value={field.value}
                                onValueChanged={(value) => {
                                    field.onChange(value);
                                    setFormData((prev) => ({
                                        ...prev,
                                        dm_trangthaihocsinh_id: value,
                                    }));
                                }}
                            />
                            {errors.dm_trangthaihocsinh_id && (
                                <FormControl.Validation variant="error">
                                    {errors.dm_trangthaihocsinh_id.message}
                                </FormControl.Validation>
                            )}
                        </FormControl>
                    )}
                />

                {/* Hàng 2 */}
                <FormControl>
                    <FormControl.Label>Họ tên (Vi)</FormControl.Label>
                    <TextInput
                        block
                        name="ho_ten"
                        register={register}
                        errors={errors}
                        required
                        validateMessage="Vui lòng điền họ tên tiếng Việt"
                    />
                </FormControl>

                <FormControl>
                    <FormControl.Label>Họ tên (En)</FormControl.Label>
                    <TextInput
                        block
                        name="ho_ten_en"
                        register={register}
                        errors={errors}
                    />
                </FormControl>

                <FormControl>
                    <FormControl.Label>Ngày sinh</FormControl.Label>
                    <Controller
                        name="ngay_sinh"
                        control={control}
                        rules={{ required: "Vui lòng điền ngày sinh" }}
                        render={({ field }) => (
                            <StyledDatePicker
                                selected={field.value ? new Date(field.value) : null}
                                onChange={(date: Date | null) => {
                                    field.onChange(date);
                                    setFormData((prev) => ({
                                        ...prev,
                                        ngay_sinh: date,
                                    }));
                                }}
                                error={errors.ngay_sinh?.message}
                            />
                        )}
                    />
                </FormControl>

                <Controller
                    name="dm_gioitinh_id"
                    control={control}
                    rules={{ required: "Vui lòng chọn giới tính" }}
                    render={({ field }) => (
                        <FormControl>
                            <FormControl.Label>Giới tính</FormControl.Label>
                            <ComboboxGioiTinh
                                value={field.value}
                                onValueChanged={(value) => {
                                    field.onChange(value);
                                    setFormData((prev) => ({
                                        ...prev,
                                        dm_gioitinh_id: value,
                                    }));
                                }}
                            />
                            {errors.dm_gioitinh_id && (
                                <FormControl.Validation variant="error">
                                    {errors.dm_gioitinh_id.message}
                                </FormControl.Validation>
                            )}
                        </FormControl>
                    )}
                />

                {/* Hàng 3 */}
                <Controller
                    name="dm_quoctich_id"
                    control={control}
                    rules={{ required: "Vui lòng chọn quốc tịch" }}
                    render={({ field }) => (
                        <FormControl>
                            <FormControl.Label>Quốc tịch</FormControl.Label>
                            <ComboboxQuocTich
                                value={field.value}
                                onValueChanged={(value) => {
                                    field.onChange(value);
                                    setFormData((prev) => ({
                                        ...prev,
                                        dm_quoctich_id: value,
                                    }));
                                }}
                            />
                            {errors.dm_quoctich_id && (
                                <FormControl.Validation variant="error">
                                    {errors.dm_quoctich_id.message}
                                </FormControl.Validation>
                            )}
                        </FormControl>
                    )}
                />

                <Controller
                    name="dm_dantoc_id"
                    control={control}
                    rules={{ required: "Vui lòng chọn dân tộc" }}
                    render={({ field }) => (
                        <FormControl>
                            <FormControl.Label>Dân tộc</FormControl.Label>
                            <ComboboxDanToc
                                value={field.value}
                                onValueChanged={(value) => {
                                    field.onChange(value);
                                    setFormData((prev) => ({
                                        ...prev,
                                        dm_dantoc_id: value,
                                    }));
                                }}
                            />
                            {errors.dm_dantoc_id && (
                                <FormControl.Validation variant="error">
                                    {errors.dm_dantoc_id.message}
                                </FormControl.Validation>
                            )}
                        </FormControl>
                    )}
                />

                <Controller
                    name="dm_tongiao_id"
                    control={control}
                    rules={{ required: "Vui lòng chọn tôn giáo" }}
                    render={({ field }) => (
                        <FormControl>
                            <FormControl.Label>Tôn giáo</FormControl.Label>
                            <ComboboxTonGiao
                                value={field.value}
                                onValueChanged={(value) => {
                                    field.onChange(value);
                                    setFormData((prev) => ({
                                        ...prev,
                                        dm_tongiao_id: value,
                                    }));
                                }}
                            />
                            {errors.dm_tongiao_id && (
                                <FormControl.Validation variant="error">
                                    {errors.dm_tongiao_id.message}
                                </FormControl.Validation>
                            )}
                        </FormControl>
                    )}
                />

                <Controller
                    name="nam_nhap_hoc"
                    control={control}
                    rules={{
                        required: "Vui lòng chọn năm nhập học",
                        validate: (value) => {
                            if (!value || !formData.nam_hoc) return true;
                            const namHoc = parseInt(
                                formData.nam_hoc?.split(" - ")[0]
                            );
                            const namNhapHoc = parseInt(value?.split(" - ")[0]);
                            return (
                                namHoc >= namNhapHoc ||
                                "Năm nhập học phải nhỏ hơn hoặc bằng năm học"
                            );
                        },
                    }}
                    render={({ field }) => (
                        <FormControl>
                            <FormControl.Label>Năm nhập học</FormControl.Label>
                            <ComboboxNamHoc
                                value={field.value}
                                onValueChanged={(value) => {
                                    field.onChange(value);
                                    setFormData((prev) => ({
                                        ...prev,
                                        nam_nhap_hoc: value,
                                    }));
                                    trigger("nam_nhap_hoc");
                                }}
                            />
                            {errors.nam_nhap_hoc && (
                                <FormControl.Validation variant="error">
                                    {errors.nam_nhap_hoc.message}
                                </FormControl.Validation>
                            )}
                        </FormControl>
                    )}
                />

                {/* Hàng 4 */}
                <FormControl>
                    <FormControl.Label>Ngày nhập học</FormControl.Label>
                    <Controller
                        name="ngay_nhap_hoc"
                        control={control}
                        render={({ field }) => (
                            <StyledDatePicker
                                selected={field.value ? new Date(field.value) : null}
                                onChange={(date: Date | null) => {
                                    field.onChange(date);
                                    setFormData((prev) => ({
                                        ...prev,
                                        ngay_nhap_hoc: date,
                                    }));
                                }}
                                error={errors.ngay_nhap_hoc?.message}
                            />
                        )}
                    />
                </FormControl>
            </Box>
        </FormBlock>
    );
};

export default ThongTinHocSinh;